import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';

const AdminSelect = ({
    label = 'Select',
    name,
    value,
    onChange,
    options = [],
    placeholder = '',
    helperText = '',
    required = false,
    className = '',
    selectClassName = '',
    loading = false,
    disabled = false,
    readOnly = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectedOption = options.find((option) => option.value?.toString() === value?.toString());

    const handleSelect = (optionValue) => {
        // Create a synthetic event object to match the expected onChange format
        const syntheticEvent = {
            target: {
                name: name,
                value: optionValue,
            },
        };
        onChange(syntheticEvent);
        setIsOpen(false);
    };

    const isDisabled = loading || disabled || readOnly;
    const showDisabledStyle = loading || disabled; // Don't show disabled style for readOnly

    return (
        <div className={`mb-4 ${className}`}>
            {label && (
                <label
                    htmlFor={name}
                    className='mb-[10px] block font-medium text-primary-400 text-sm'
                >
                    {label} {required && <span className='text-red-500'>*</span>}
                </label>
            )}
            <div className='relative'>
                <button
                    type='button'
                    onClick={() => !isDisabled && setIsOpen(!isOpen)}
                    disabled={isDisabled}
                    className={`w-full border border-[#e1e3ea] p-3 text-sm rounded-lg active:outline-none focus:outline-none text-left ${selectClassName} ${showDisabledStyle ? 'opacity-50 cursor-not-allowed bg-gray-100' : readOnly ? 'cursor-default' : ''}`}
                >
                    <div className='flex items-center justify-between'>
                        <span className={selectedOption ? 'text-gray-900' : 'text-gray-500'}>
                            {loading ? 'Loading...' : (selectedOption ? selectedOption.label : (placeholder || `Select ${label}`))}
                        </span>
                        <ChevronDown
                            className={`w-4 h-4 text-gray-400 transition-transform ${
                                isOpen ? 'rotate-180' : ''
                            }`}
                        />
                    </div>
                </button>

                {isOpen && !isDisabled && (
                    <>
                        {/* Backdrop */}
                        <div className='fixed inset-0 z-10' onClick={() => setIsOpen(false)} />

                        {/* Dropdown Menu */}
                        <div className='absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto'>
                            {options.map((option, index) => (
                                <button
                                    key={index}
                                    type='button'
                                    onClick={() => handleSelect(option.value)}
                                    className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 focus:bg-gray-50 focus:outline-none first:rounded-t-lg last:rounded-b-lg ${
                                        value?.toString() === option.value?.toString()
                                            ? 'bg-red-50 text-red-600'
                                            : 'text-gray-900'
                                    }`}
                                >
                                    <div className='flex items-center justify-between'>
                                        <span>{option.label}</span>
                                        {value?.toString() === option.value?.toString() && (
                                            <Check className='w-4 h-4 text-red-600' />
                                        )}
                                    </div>
                                </button>
                            ))}
                        </div>
                    </>
                )}
            </div>

            {helperText && <p className='text-xs text-[#a1a5b7] font-normal my-1 '>{helperText}</p>}
        </div>
    );
};

export default AdminSelect;